import { useEffect } from 'react';

import picsartApi from '../../../../services/picsartAuth';
import { AnalyticsGTM } from '../../../../services/analytics-gtm';
import { AUTH_ACCEPTED_ORIGIN } from '../../../../services/constants';
import { useLoginStore, LoginState } from '../LoginStore';
import { log } from '../utils';

export function useIframeCommunication(closePopup: () => void, analytics: AnalyticsGTM) {
  const setLoginState = useLoginStore((state) => state.setLoginState);

  useEffect(() => {
    window.addEventListener('message', async ({ origin, data }: MessageEvent) => {
      if (origin !== AUTH_ACCEPTED_ORIGIN) {
        log(`Wrong iframe origin ${origin}`);
        return;
      }

      if (!data) {
        log('No data sent from iframe');
        return;
      }

      closePopup();
      try {
        await picsartApi.exchange(data);

        setLoginState(LoginState.In);
        analytics.pageClick({
          page_path: window.location.pathname,
          action_type: 'account_logged_in',
        });
      } catch (err) {
        log(`Could not exchange code for access_token: ${err?.response?.data?.error}`);
      }
    });
  }, []);
}
